import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import ProjectBudget from "@/components/ProjectBudget";
import { ArrowLeft } from "@phosphor-icons/react";

export default function ProjectBudgetPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);

  useEffect(() => {
    api.get(`/projects/${id}`).then(r => setProject(r.data)).catch(() => navigate("/projects"));
  }, [id, navigate]);

  if (!project) return <div className="p-8 text-center text-muted-foreground">Loading…</div>;

  return (
    <div>
      <div className="border-b border-border px-8 lg:px-12 py-8">
        <Link to={`/projects/${id}`} className="text-xs font-mono-mini text-muted-foreground hover:text-[#002FA7] flex items-center gap-1 mb-2">
          <ArrowLeft size={12} weight="bold" /> Back to Kanban
        </Link>
        <div className="eyebrow mb-2">Project · {project.name}</div>
        <h1 className="font-display text-4xl font-black tracking-tight">Budget & Cost Tracker</h1>
        <p className="text-sm text-muted-foreground mt-2">Track planned vs consumed with labor (from timesheets × role rates), expenses, and custom line items.</p>
      </div>

      <div className="p-8 lg:p-12">
        <ProjectBudget projectId={id} project={project} onProjectUpdate={setProject} />
      </div>
    </div>
  );
}
